import React from 'react';
import { ComingSoon } from '../ComingSoon';

export const Terms = () => {
  return <ComingSoon title="Terms of Service" />;
};
